import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import styles from "./Spark1.module.css";
import spark from "../../images/spark1.png";
const Spark = ({ x, y }: { x: number; y: number }) => {
  return (
    <motion.div
      initial={{ opacity: 1, x, y, scale: 0.1 }}
      animate={{
        opacity: 1,
        x: x - (Math.random() * 150 - 75),
        y: y + Math.random() * 150,
        scale: Math.random() * 0.5 + 0.3,
      }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className={styles.spark}
    >
      <img src={spark} alt="spark" />
    </motion.div>
  );
};

export default function Spark1() {
  const [sparks, setSparks] = useState<{ id: number; x: number; y: number }[]>(
    []
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setSparks((prev) => [
        ...prev,
        { id: Date.now(), x: Math.random() * 200, y: Math.random() * 50 + 100 },
      ]);
      setTimeout(() => {
        setSparks((prev) => prev.slice(1));
      }, 500);
    }, 100);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={styles.container}>
      {sparks.map((spark) => (
        <Spark key={spark.id} x={spark.x} y={spark.y} />
      ))}
    </div>
  );
}
